import React from 'react';
import { ActionButtonOutline, Assignee } from './TaskTable.styles';
import { Task, TaskStatus } from './types';
import { Icon } from 'bench-internal-theme';
import { assigneeTypeLookup } from './assigneeTypeLookup';

const AssigneeColumn = ({
  task,
  assignTask,
  isClientTaskManager,
}: {
  task: Task;
  assignTask?: (task: Task) => void;
  isClientTaskManager: boolean;
}) => {
  const handleOnClick: React.MouseEventHandler<HTMLButtonElement> = event => {
    event.stopPropagation();
    assignTask && assignTask(task);
  };

  if (isClientTaskManager) {
    return (
      <Assignee>
        {(task.assignedPerson?.fullName || 'Unassigned') +
          ' | ' +
          (assigneeTypeLookup[task.assigneeType] || task.assigneeType)}
      </Assignee>
    );
  }

  if (task.assignedPerson?.id) {
    return (
      <Assignee>
        <>
          {task.assignedPerson.fullName} |{' '}
          {assigneeTypeLookup[task.assigneeType] || task.assigneeType}
          {task.status === TaskStatus.PENDING_WORK ? (
            <Icon
              onClick={handleOnClick}
              aria-label="remove task assignee"
              icon="close"
              color="#CC463A"
            />
          ) : undefined}
        </>
      </Assignee>
    );
  }

  return (
    <Assignee>
      {task.status === TaskStatus.PENDING_WORK ? (
        <ActionButtonOutline onClick={handleOnClick}>Assign to me</ActionButtonOutline>
      ) : undefined}
    </Assignee>
  );
};

export default AssigneeColumn;
